// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reuse-row{display:flex;flex-wrap:wrap;margin:0 -6px}@media only screen and (max-width:1000px){.reuse-row{margin:0}}@media only screen and (max-width:500px){.reuse-row{justify-content:space-between;padding:0 16px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
